import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function IngatlanPiac() {
  return (
    <div className="bg-black text-white min-h-screen">
      
      {/* Hero */}
      <section className="relative py-16 md:py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-[#111]">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black mb-4">
            Ingatlan piactér
          </h1>
          <p className="text-xl md:text-2xl text-secondary font-semibold mb-6">
            Eladó és kiadó ingatlanok egy helyen.
          </p>
          <p className="text-gray-400 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            Egyszerű feltöltés, célzott megjelenés, átlátható rendszer.
            Töltsd fel az ingatlanod, mi eljuttatjuk a megfelelő vevőhöz.
          </p>
        </div>
      </section>

      {/* Main Actions */}
      <section className="py-12 md:py-20 bg-[#0a0a0a]">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-6">
            
            {/* Ingatlant keresek */}
            <Link
              to="/elado-ingatlanok"
              className="group bg-[#1a1a1a] rounded-2xl p-8 border border-white/10 hover:border-secondary/50 transition-all no-underline"
            >
              <span className="text-5xl mb-4 block">🔍</span>
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-secondary transition-colors">
                Ingatlant keresek
              </h3>
              <p className="text-gray-400 text-sm mb-4">
                Böngéssz az eladó és kiadó ingatlanok között. Találd meg az ideális otthont vagy befektetési lehetőséget.
              </p>
              <span className="text-secondary text-sm font-medium flex items-center gap-2">
                Ingatlanok böngészése <span className="group-hover:translate-x-1 transition-transform">→</span>
              </span>
            </Link>
            
            {/* Ingatlant hirdetek */}
            <Link
              to="/hoppx-sajat-ingatlan"
              className="group bg-[#1a1a1a] rounded-2xl p-8 border border-white/10 hover:border-secondary/50 transition-all no-underline"
            >
              <span className="text-5xl mb-4 block">📤</span>
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-secondary transition-colors">
                Ingatlant hirdetek
              </h3>
              <p className="text-gray-400 text-sm mb-4">
                Töltsd fel az eladó vagy kiadó ingatlanodat. AI-támogatott feltöltési folyamat, profi megjelenés.
              </p>
              <span className="text-secondary text-sm font-medium flex items-center gap-2">
                Ingatlan feltöltése <span className="group-hover:translate-x-1 transition-transform">→</span>
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-12 md:py-20 bg-[#111]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Miért a HoppHomes piactér?
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary/20 rounded-xl flex items-center justify-center text-3xl mx-auto mb-4">
                🤖
              </div>
              <h3 className="text-white font-semibold mb-2">AI-támogatott feltöltés</h3>
              <p className="text-gray-400 text-sm">Automatikus leírás és optimalizálás mesterséges intelligenciával</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary/20 rounded-xl flex items-center justify-center text-3xl mx-auto mb-4">
                🎯
              </div>
              <h3 className="text-white font-semibold mb-2">Célzott elérés</h3>
              <p className="text-gray-400 text-sm">Az ingatlanodat a megfelelő vevők látják</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary/20 rounded-xl flex items-center justify-center text-3xl mx-auto mb-4">
                💎
              </div>
              <h3 className="text-white font-semibold mb-2">Prémium megjelenés</h3>
              <p className="text-gray-400 text-sm">Professzionális hirdetés, minőségi platform</p>
            </div>
          </div>
        </div>
      </section>

      {/* Seller Benefits */}
      <section className="py-12 md:py-20 bg-[#0a0a0a]">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Eladóknak
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5">
              <h3 className="text-white font-bold mb-3 flex items-center gap-2">
                <span className="text-green-400">✓</span> Egyszerű feltöltés
              </h3>
              <p className="text-gray-400 text-sm">
                Pár perc alatt feltöltheted az ingatlanodat. Az AI segít a leírás elkészítésében.
              </p>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5">
              <h3 className="text-white font-bold mb-3 flex items-center gap-2">
                <span className="text-green-400">✓</span> Ingyenes alapcsomag
              </h3>
              <p className="text-gray-400 text-sm">
                Az alap hirdetés ingyenes. Prémium opciókkal kiemelheted az ingatlanodat.
              </p>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5">
              <h3 className="text-white font-bold mb-3 flex items-center gap-2">
                <span className="text-green-400">✓</span> Valós érdeklődők
              </h3>
              <p className="text-gray-400 text-sm">
                Előminősített érdeklődők, akik komolyan keresnek ingatlant.
              </p>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5">
              <h3 className="text-white font-bold mb-3 flex items-center gap-2">
                <span className="text-green-400">✓</span> Statisztikák
              </h3>
              <p className="text-gray-400 text-sm">
                Kövesd nyomon, hányan nézték meg a hirdetésedet.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Features */}
      <section className="py-12 md:py-20 bg-[#111]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <span className="inline-block bg-purple-500/20 text-purple-400 text-xs font-bold px-3 py-1 rounded-full mb-4">
            HAMAROSAN
          </span>
          <h2 className="text-2xl md:text-3xl font-bold mb-6">
            Jövőbeli funkciók
          </h2>
          <div className="grid md:grid-cols-3 gap-4 text-left">
            <div className="bg-[#1a1a1a]/50 rounded-xl p-4 border border-purple-500/20">
              <span className="text-2xl mb-2 block">🪙</span>
              <h3 className="text-white font-semibold text-sm mb-1">HOPPx token</h3>
              <p className="text-gray-500 text-xs">Jutalmak és kedvezmények tokennel</p>
            </div>
            <div className="bg-[#1a1a1a]/50 rounded-xl p-4 border border-purple-500/20">
              <span className="text-2xl mb-2 block">💸</span>
              <h3 className="text-white font-semibold text-sm mb-1">Cashback</h3>
              <p className="text-gray-500 text-xs">Visszatérítés sikeres tranzakció után</p>
            </div>
            <div className="bg-[#1a1a1a]/50 rounded-xl p-4 border border-purple-500/20">
              <span className="text-2xl mb-2 block">🤝</span>
              <h3 className="text-white font-semibold text-sm mb-1">Ajánlói rendszer</h3>
              <p className="text-gray-500 text-xs">Keress pénzt ajánlásokkal</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-[#0a0a0a] to-black">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-4xl font-bold mb-4">
            Kezdj el hirdetni még ma!
          </h2>
          <p className="text-gray-400 mb-8">
            Töltsd fel az ingatlanodat, és eljuttatjuk a megfelelő vevőhöz.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/hoppx-sajat-ingatlan"
              className="bg-secondary hover:bg-hover text-white font-bold px-8 py-4 rounded-xl transition-all"
            >
              📤 Ingatlan feltöltése
            </Link>
            <Link
              to="/elado-ingatlanok"
              className="bg-white/10 hover:bg-white/20 text-white font-bold px-8 py-4 rounded-xl border border-white/[0.08] transition-all"
            >
              🔍 Ingatlanok böngészése
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
